import { Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import { useFlowContext } from '_/contexts/FlowContext';
import React, { ReactElement } from 'react';

function AlarmGroupsContainer(): ReactElement {
  const { flowId, isLoading } = useFlowContext();

  return (
    <AsyncPageContainer isLoading={!flowId || isLoading}>
      <Outlet />
    </AsyncPageContainer>
  );
}

export default AlarmGroupsContainer;
